import React, { useState } from "react";
import ECLThemeImage from "../../../../Widgets/ECLThemeImage/ECLThemeImage";

export default function ExplorerSort({ columnIndex, rowData, setRowData }) {
   const [sortOrder, setSortOrder] = useState("asc");
   if (!rowData) {
      return null;
   }
   let handleSort;
   let sortedData;
   const firstItem = rowData[0].row[columnIndex];
   const type = typeof firstItem;
   if (type === "number") {
      handleSort = handleNumericalSort;
   } else if (type === "string") {
      handleSort = handleStringSort;
   }

   function toggleSortOrder() {
      if (sortOrder === "asc") {
         setSortOrder("desc");
      } else {
         setSortOrder("asc");
      }
   }

   function handleStringSort() {
      if (sortOrder === "desc") {
         sortedData = [...rowData].sort((a, b) => {
            return a.row[columnIndex].localeCompare(b.row[columnIndex]);
         });
      } else {
         sortedData = [...rowData].sort((a, b) => {
            return b.row[columnIndex].localeCompare(a.row[columnIndex]);
         });
      }
      toggleSortOrder();
      setRowData(sortedData);
   }

   function handleNumericalSort() {
      if (sortOrder === "desc") {
         sortedData = rowData.slice().sort((a, b) => {
            return b.row[columnIndex] - a.row[columnIndex];
         });
      } else {
         sortedData = rowData.slice().sort((a, b) => {
            return a.row[columnIndex] - b.row[columnIndex];
         });
      }
      toggleSortOrder();
      setRowData(sortedData);
   }

   return (
      <button onClick={handleSort} style={{ textAlign: "center" }}>
         <ECLThemeImage
            fontAwesome={sortOrder === "asc" ? "angle-up" : "angle-down"}
         />
      </button>
   );
}
